import { SalesActionsType } from 'api-hooks/general/model';
import { SaleModel } from 'api-hooks/sale/common';
import { NavigationRoutes } from 'common/constants';
import { FormAutoSaver } from 'common/helpers/form-auto-saver';
import notification from 'components/common/notification';
import { PopoverMenuType } from 'components/popover';
import useNavigation from 'hooks/use-navigation';
import { ProductSaleFormType } from 'legacy-modules/product/sales/components/form-type';
import { TourSaleFormType } from 'legacy-modules/tour/tour-sale/components/form-type';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import { ActivitySaleFormType } from '../activity/components/form-type';
import { CruiseSaleFormType } from '../cruise/components/form-type';
import { HotelSaleFormType } from '../hotel/components/form-type';
import { TicketSaleFormType } from '../ticket-sale/components/form-type';
import { DocumentSaleFormType } from '../travel-document/components/form-type';

export default function useSalesDuplicate(
  type: SalesActionsType,
  data: SaleModel,
  defaultValues:
    | HotelSaleFormType
    | DocumentSaleFormType
    | CruiseSaleFormType
    | TicketSaleFormType
    | ActivitySaleFormType
    | TourSaleFormType
    | ProductSaleFormType,
) {
  const { t } = useTranslation();
  const { navigate } = useNavigation();
  const duplicatePermission = true; //all status can edit

  const createSaleRouter = React.useMemo(() => {
    switch (type) {
      case 'flight-sales':
        return NavigationRoutes.TicketSalesCreate;
      case 'hotel-sales':
        return NavigationRoutes.HotelSalesCreate;
      case 'cruise-sales':
        return NavigationRoutes.CruiseSalesCreate;
      case 'document-sales':
        return NavigationRoutes.TravelDocumentSalesCreate;
      case 'activity-sales':
        return NavigationRoutes.ActivitySalesCreate;
      case 'product-sales':
        return NavigationRoutes.ProductSalesCreate;
      case 'tour-sales':
        return NavigationRoutes.TourSalesCreate;
    }
  }, [type]);

  const onDuplicate = React.useCallback(() => {
    if (duplicatePermission) {
      FormAutoSaver.remove(createSaleRouter);
      navigate(createSaleRouter, {
        defaultValues: defaultValues as any,
      });
    } else {
      notification.error({
        message: t('common:unauthorized_action'),
      });
    }
  }, [duplicatePermission, navigate, createSaleRouter, defaultValues, t]);

  const duplicateInvoiceAction: PopoverMenuType = {
    label: t('common:duplicate_invoice'),
    onClick: onDuplicate,
    isAllowed: duplicatePermission,
    isError: false,
    key: `duplicate-${data.id}`,
  };

  return {
    duplicateInvoiceAction,
    onDuplicate,
    createSaleRouter,
    duplicatePermission,
  };
}
